import { useState, useEffect } from 'react';
import { raiseToast } from '@fiverr-private/toast';
import { translate } from '@fiverr-private/i18n-react';

const usePaymentSuccessToast = () => {
    const [hasHandledToast, setHasHandledToast] = useState(false);

    useEffect(() => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        const complianceType = searchParams.get('complianceSentType');

        if (complianceType && !hasHandledToast) {
            raiseToast({
                location: 'top',
                type: 'success',
                message: translate(`compliance.toast.${complianceType}.success`),
            });
            setHasHandledToast(true);

            searchParams.delete('complianceSentType');
            const newUrl = `${url.pathname}?${searchParams.toString()}`.replace(/\?$/, '');

            window.history.replaceState(null, '', newUrl);
        }
    }, [hasHandledToast]);
};

export default usePaymentSuccessToast;
